var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.394,
    height: 27.962,
    viewBox: "0 0 55.394 27.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49475",
    "data-name": "Path 49475",
    d: "M3653.4,3475.76s4.09-3.041,6.921-1.258,1.52,7.235,4.4,8.389,2.674-9.176,5.663-5.033,1.573,17.774,4.614,21.182,3.985-5.715,6.082-7.76,2.254,1.1,3.985,0,1.1-4.4,2.936-4.4,2.359,3.775,4.4,4.4,1.835-2.2,3.775-1.887,1.521,3.146,3.985,3.146,4.4-2.359,5.872-3.146",
    transform: "translate(-3651.997 -3472.831)",
    fill: "none",
    stroke: "#f7931a",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphImg);
export default __webpack_public_path__ + "static/media/graphImg.030efe209e9c4017deff62ed7f1193eb.svg";
export { ForwardRef as ReactComponent };